<template>
  <header class="vailentine-header">
    <h1 class="vailentine-header__heading">v<span class="vailentine-header__asterisk">*</span>AI<span class="vailentine-header__asterisk">*</span>lentine</h1>
    <button class="vailentine-header__about" @click.prevent="showAbout">
      <img src="/static/img/info_icon.svg">
    </button>
    <transition name="fade">
      <div class="vailentine-header__about-modal-mask" v-if="showAboutModal" @click.prevent="closeAbout"></div>
    </transition>
    <transition name="fade">
      <div class="vailentine-header__about-modal" v-if="showAboutModal">
        <div class="vailentine-header__about-modal-inner">
          <div class="vailentine-header__about-modal-close" v-if="showAboutModal" @click.prevent="closeAbout">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
                <g class="nc-icon-wrapper" fill="#111111">
                    <path d="M38 12.83L35.17 10 24 21.17 12.83 10 10 12.83 21.17 24 10 35.17 12.83 38 24 26.83 35.17 38 38 35.17 26.83 24z"></path>
                </g>
            </svg>
          </div>

          <p>v*AI*lentine is a machine intelligent love poem generator. Users enter their name, their sweetheart’s name, and answer a few questions.</p>
          <p>With these inputs, v*AI*lentine uses Markov chains, natural language processing, and the entirety of Shakespeare’s sonnets to algorithmically generate custom poetry for your loved one.</p>
          <p>Shout out to the lovely <a href="https://github.com/jsvine/markovify" target="_blank">Markovify</a> library.</p>

          <h1 class="vailentine-header__about-heading"><span>Made with</span> <img class="vailentine-header__about-heart" src="/static/img/r_heart.svg"> <span>by <a href="https://www.hugeinc.com/" target="_blank">Huge</a></span></h1>
        </div>
      </div>
    </transition>
  </header>
</template>

<script>
export default {
  name: 'VailentineHeader',

  data () {
    return {
      showAboutModal: false
    }
  },

  methods: {
    closeAbout () {
      this.showAboutModal = false
    },

    showAbout () {
      this.showAboutModal = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/sass/mixins';
@import '../assets/sass/placeholders';
@import '../assets/sass/variables';

.vailentine-header {
  background: $white;
}

.vailentine-header__heading {
  @extend %h4;

  color: $red-2;
  margin: 0 auto;
  padding: 15px 0;
}

.vailentine-header__asterisk {
  display: inline-block;
  font-family: lato;
  transform: translate(0, 10px);
}

.vailentine-header__about {
  background: 0;
  border: 0;
  cursor: pointer;
  padding: 16px 20px 10px;
  position: absolute;
  left: 10px;
  top: 10px;
}

.vailentine-header__about-modal-mask {
  background: rgba(218, 69, 83, .8);
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}

.vailentine-header__about-modal {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  left: 0;
  pointer-events: none;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10001;
}

.vailentine-header__about-modal-inner {
  -webkit-overflow-scrolling: touch;
  background: $white;
  border: 1px solid $grey-3;
  color: $grey-5;
  font-size: 18px;
  height: calc(100% - 40px);
  line-height: 1.5;
  margin: 20px;
  overflow-y: scroll;
  padding: 25px;
  pointer-events: auto;
  width: calc(100% - 40px);

  @include from-breakpoint(md) {
    font-size: 21px;
    height: auto;
    max-width: 560px;
    padding: 20px 50px;
  }
}

.vailentine-header__about-modal-close {
  cursor: pointer;
  height: 32px;
  position: absolute;
  right: 40px;
  top: 24px;
  width: 32px;

  .nc-icon-wrapper {
    fill: $grey-3;
  }

  @include from-breakpoint(md) {
    right: 32px;
    top: 14px;

    .nc-icon-wrapper {
      fill: $white;
    }
  }
}

.vailentine-header__about-heading {
  @extend %h5;

  color: $red-2;
  text-align: left;

  @include from-breakpoint(md) {
    font-size: 30px;
  }

  img,
  span {
    vertical-align: middle;
  }

  span {
    display: inline-block;
  }

  a {
    color: $pink-2;
    transition: color 250ms;

    &:visited,
    &:active,
    &:hover {
      color: $pink-2;
    }
  }
}

.vailentine-header__about-heart {
  max-width: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/VailentineHeader.vue